export function getAuthHeaders(): Promise<Record<string, string>> {
  throw new Error('getAuthHeaders has not been implemented for this platform')
}
